import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import Input from '../components/Input';
import Button from '../components/Button';
import { useParams } from 'react-router';
import _ from 'lodash';
import PasswordStrengthBar from 'react-password-strength-bar';
import { makeStyles } from '@mui/styles';
import AlertModal from '../components/AlertModal';
import { AxiosError, AxiosResponse } from 'axios';
import jwt_decode from "jwt-decode";
import { resetPassword } from '../methods/Methods';
import { GenericResponse, RequestResetPassword, ResponseResetPassword } from '../types/types';

type TParams = { resetToken: string };

const ResetPasswordScreen = () => {
    const classes = styles();

    const [password, setPassword] = React.useState("");
    const [password2, setPassword2] = React.useState("");
    const reg = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})');
    const [isOpenDialog, setIsOpenDialog] = React.useState<boolean>(false);
    const params = useParams<TParams>();
    const [message, setMessage] = React.useState<string>("");
    const [showPassword1, setShowPassword1] = React.useState<boolean>(false);
    const [showPassword2, setShowPassword2] = React.useState<boolean>(false);
    const [expiredToken, setExpiredToken] = React.useState<boolean>(false);

    const changePwd = async () => {
        let validPassword = reg.test(password);

        if (password && password2) {
            if (password === password2) {
                if (validPassword && password.length < 16) {
                    let request: RequestResetPassword = {
                        newPassword: password,
                        resetLink: (params.resetToken) ? params.resetToken : "",
                    };

                    await resetPassword(request)
                        .then((response: AxiosResponse<GenericResponse<ResponseResetPassword>>) => {
                            if (response.data.data[0].message) {
                                setMessage(response.data.data[0].message);
                            } else {
                                setMessage("Hubo un error al intentar procesar su solicitud, solicite ayuda con el área de soporte a suscriptores.")
                            }
                        })
                        .catch((error: AxiosError) => {
                            setMessage("Hubo un error al intentar procesar su solicitud, solicite ayuda con el área de soporte a suscriptores.");
                        })
                } else {
                    setMessage("La contraseña debe tener al menos 8 caracteres y máximo 15 caracteres, un número, una letra mayúscula, una letra minúscula y un caracter especial.");
                }
            } else {
                setMessage("La contraseña no coincide");
            }
        } else {
            setMessage("Ambos campos son requeridos");
        }
        setIsOpenDialog(true);
    };

    const changeVisibility = (element: number) => {
        if (element === 1) {
            setShowPassword1(!showPassword1)
        } else if (element === 2) {
            setShowPassword2(!showPassword2)
        }
    };


    useEffect(() => {
        if (params && params.resetToken) {
            const decoded = jwt_decode(params.resetToken) as { exp: number };
            const currentTime = Date.now() / 1000;

            if (currentTime > decoded.exp) {
                setExpiredToken(true);
            } else {
                setExpiredToken(false);
            }
        }
    }, [params]);

    return (
        <div className={classes.container}>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: '20px', height: '100%' }}>
                <div className={classes.logoContainer}>
                    <img
                        src="../../mega-logo.jpg"
                        alt="logo"
                        className={classes.logo}
                    />
                </div>
                <p className={classes.title}>
                    Estimado Suscriptor
                </p>
                {
                    expiredToken ? (
                        <div>
                            <p className={classes.text}>
                                ¡Lo sentimos! El token es incorrecto o ha expirado.
                            </p>
                        </div>
                    ) :
                        message === "La contraseña ha sido cambiada con exito." ? (
                            <div>
                                <p className={classes.text}>
                                    Su contraseña ha sido cambiada correctamente. Ahora puede {' '}
                                    <a href="https://sel.megacable.com.mx/" target="_blank" rel="noopener noreferrer">iniciar sesión aquí</a> {' '}
                                    para acceder a su cuenta con la nueva contraseña.
                                </p>
                            </div>
                        ) : (
                            <>
                                <p className={classes.textCaps}>Ha solicitado restablecer su contraseña para</p>
                                <p className={classes.textCaps}>ingresar a servicios en línea.</p>
                                <p className={classes.textNormal}>La contraseña debe tener:</p>
                                <div className={classes.containerBullets}>
                                    <p className={classes.textBetween}>• Entre 8 y 15 caracteres</p>
                                    <p className={classes.textBetween}>• Al menos una letra mayúscula</p>
                                    <p className={classes.textBetween}>• Al menos una letra minúscula</p>
                                    <p className={classes.textBetween}>• Al menos un número</p>
                                    <p className={classes.textBetween}>• Al menos un caracter especial</p>
                                </div>
                                {/* <p className={classes.textSmall}>(Al menos un número, una letra mayúscula y un caracter especial)</p> */}
                                {/* <p className={classes.textNormal}>No se permiten los siguientes</p>
                        <p className={classes.textNormal} style={{ margin: 0 }}>caracteres especiales:</p>
                        <div style={{ display: 'flex', justifyContent: ' center' }}>
                            <p className={classes.textSpecialChar}>{"\u005C\u0027)(,*%=><;"}</p>
                        </div> */}
                                <p className={classes.textCaps} style={{ marginTop: "40px" }}>
                                    Ingrese y confirme su nueva contraseña
                                </p>
                                <div className={classes.inputContainer}>
                                    <Input
                                        title="Nueva Contraseña*"
                                        colorTitle={'#004B9D'}
                                        type={showPassword1 ? 'text' : 'password'}
                                        placeholder=""
                                        value={password}
                                        onChange={(e: any) => setPassword(e.target.value)}
                                        onKeyUp={(e) => {
                                            e.persist();
                                            let pressedEnter = (_.find(e, ['key', "Enter"]));
                                            if (pressedEnter) {
                                                changePwd();
                                            }
                                        }}
                                        showPassword={showPassword1}
                                        changeVisibility={() => changeVisibility(1)}
                                    />
                                    <Input
                                        title="Confirmar la contraseña*"
                                        colorTitle={'#004B9D'}
                                        type={showPassword2 ? 'text' : 'password'}
                                        placeholder=""
                                        value={password2}
                                        onChange={(e: any) => setPassword2(e.target.value)}
                                        onKeyUp={(e) => {
                                            e.persist();
                                            let pressedEnter = (_.find(e, ['key', "Enter"]));
                                            if (pressedEnter) {
                                                changePwd();
                                            }
                                        }}
                                        showPassword={showPassword2}
                                        changeVisibility={() => changeVisibility(2)}
                                    />
                                </div>
                                <div style={{ margin: '40px 0px 0px 0px' }}>
                                    <PasswordStrengthBar
                                        shortScoreWord={'Muy corta'}
                                        scoreWords={['Débil', 'Débil', 'Mediana', 'Fuerte', 'Muy fuerte']}
                                        password={password}
                                    />
                                </div>
                                <div className={classes.buttonContainer}>
                                    <Button
                                        type="primary"
                                        text="CONFIRMAR"
                                        size="medium"
                                        onClick={() => changePwd()}
                                    />
                                </div>
                            </>
                        )}
            </Grid>
            <AlertModal
                open={isOpenDialog}
                onExit={() => setIsOpenDialog(false)}
                text={message}
            />
        </div>
    )
};

const styles = makeStyles({
    container: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'withe'
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '10px'
    },
    logo: {
        width: '250px',
    },
    title: {
        fontSize: '15px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        paddingTop: '30px',
        fontFamily: "Sarabun"
    },
    text: {
        justifyContent: 'space-around',
        fontFamily: "Sarabun"
    },
    textSmall: {
        display: 'flex',
        justifyContent: 'space-around',
        fontSize: '14px',
        fontFamily: "Sarabun"
    },
    textSpecialChar: {
        textAlign: 'center',
        letterSpacing: 5,
        backgroundColor: "#004B9E",
        padding: 10,
        borderRadius: 5,
        color: 'white',
        fontWeight: 600,
        width: 150
    },
    textCaps: {
        color: '#004B9E',
        fontWeight: 600,
        fontFamily: "Sarabun",
        display: 'flex',
        textTransform: 'uppercase',
        margin: '5px',
        fontSize: '20px'
    },
    textNormal: {
        color: '#004B9D',
        display: 'flex',
        margin: '30px 0px 30px 30px',
        fontSize: '22px',
        fontFamily: "Sarabun"
    },
    textBetween: {
        fontSize: '18px',
        fontFamily: "Sarabun",
        margin: "0px"
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '15px',
        paddingBottom: '15px'
    },
    inputContainer: {
        paddingTop: '25px'
    },
    containerBullets: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        left: "26%",
    }
});

export default ResetPasswordScreen;
